import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/account_balance.svg'
import _imports_1 from '@/assets/svg/union.svg'
import _imports_2 from '@/assets/svg/safety.svg'
import _imports_3 from '@/assets/svg/credibility.svg'
import _imports_4 from '@/assets/images/tourism.png'
import _imports_5 from '@/assets/images/league_second.png'
import _imports_6 from '@/assets/images/bridge.png'
import _imports_7 from '@/assets/images/veles.png'
import _imports_8 from '@/assets/svg/line-small.svg'
import _imports_9 from '@/assets/svg/line-middle.svg'
import _imports_10 from '@/assets/svg/line-big.svg'
import _imports_11 from '@/assets/images/spb.png'
import _imports_12 from '@/assets/images/russia.png'
import _imports_13 from '@/assets/images/globe.png'
import _imports_14 from '@/assets/images/school.png'
import _imports_15 from '@/assets/images/medicine.png'
import _imports_16 from '@/assets/images/ships.png'
import _imports_17 from '@/assets/images/admiral.png'
import _imports_18 from '@/assets/images/smolniy.png'
import _imports_19 from '@/assets/images/cremlin.png'
import _imports_20 from '@/assets/images/pushka.png'
import _imports_21 from '@/assets/images/murmansk.png'
import _imports_22 from '@/assets/images/ledocol.png'
import _imports_23 from '@/assets/svg/dop_1.svg'
import _imports_24 from '@/assets/svg/dop_2.svg'
import _imports_25 from '@/assets/svg/dop_3.svg'
import _imports_26 from '@/assets/svg/dop_4.svg'
import _imports_27 from '@/assets/svg/dop_5.svg'
import _imports_28 from '@/assets/svg/dop_6.svg'
import _imports_29 from '@/assets/images/logo_btm.png'


const _withScopeId = n => (_pushScopeId("data-v-181e11d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-section" }
const _hoisted_2 = { class: "contacts flex justify-end gap-x-10 mr-[214px] l:mt-[120px] xxl:mb-[140px] relative z-20" }
const _hoisted_3 = { href: "tel:+79112660098" }
const _hoisted_4 = { href: "mailto:reserv@rvm-spb.ru" }
const _hoisted_5 = { href: "mailto:info@rvm-spb.ru" }
const _hoisted_6 = { class: "relative z-10 px-[120px]" }
const _hoisted_7 = { class: "xl:mb-10 xxl:mb-[80px]" }
const _hoisted_8 = { class: "xl:mb-2 xxl:mb-6" }
const _hoisted_9 = { class: "pl-[56px] xl:mb-2 xxl:mb-6" }
const _hoisted_10 = { class: "pl-[112px]" }
const _hoisted_11 = { class: "flex flex-col items-center justify-center" }
const _hoisted_12 = {
  key: 0,
  class: "form box"
}
const _hoisted_13 = { class: "flex flex-col items-center justify-center" }
const _hoisted_14 = { class: "l:h-[860px] l:w-[1126px] mx-auto second-section relative mt-[84px] mb-[30px]" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overlay" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horseman" }, null, -1))
const _hoisted_17 = { class: "mb-[82px]" }
const _hoisted_18 = { class: "flex flex-col gap-y-10" }
const _hoisted_19 = { class: "flex flex-row items-center gap-x-8" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-9 h-9 l:h-[80px] l:w-[80px]"
}, null, -1))
const _hoisted_21 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 l:h-[25px] l:w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_23 = { class: "flex flex-row items-center gap-x-8" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-9 h-9 l:h-[80px] l:w-[80px]"
}, null, -1))
const _hoisted_25 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 l:h-[25px] l:w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_27 = { class: "flex flex-row items-center gap-x-8" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-9 h-9 l:h-[80px] l:w-[80px]"
}, null, -1))
const _hoisted_29 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 l:h-[25px] l:w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_31 = { class: "flex flex-row items-center gap-x-8" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-9 h-9 l:h-[80px] l:w-[80px]"
}, null, -1))
const _hoisted_33 = { class: "flex flex-row gap-x-4 items-center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-3 w-3 l:h-[25px] l:w-[25px] bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_35 = { class: "flex flex-col gap-y-16 mb-[84px] w-[1126px] mx-auto" }
const _hoisted_36 = { class: "flex flex-col gap-y-10 w-full" }
const _hoisted_37 = { class: "flex flex-row justify-end gap-x-8" }
const _hoisted_38 = ["src"]
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<section class=\"flex flex-col gap-y-4 items-center mb-[84px]\" data-v-181e11d4><div class=\"bridge-wrapper mb-[60px]\" data-v-181e11d4><div class=\"bridge-layout\" data-v-181e11d4></div><img src=\"" + _imports_6 + "\" class=\"bridge\" data-v-181e11d4></div><img src=\"" + _imports_7 + "\" class=\"w-[250px]\" data-v-181e11d4></section>", 1)
const _hoisted_40 = { class: "mb-[84px]" }
const _hoisted_41 = { class: "flex flex-col items-center justify-center w-full" }
const _hoisted_42 = { class: "p-[10px]" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_8 }, null, -1))
const _hoisted_44 = { class: "p-[10px]" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_9 }, null, -1))
const _hoisted_46 = { class: "p-[10px]" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_10 }, null, -1))
const _hoisted_48 = { class: "flex flex-col items-center justify-center" }
const _hoisted_49 = { class: "h-[860px] w-[1126px] mx-auto second-section relative mb-[168px]" }
const _hoisted_50 = { class: "px-[100px]" }
const _hoisted_51 = { class: "grid grid-cols-3 gap-x-16 mb-7" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-[52px] border-[3px] rounded-[80px] border-[var(--primary-color)]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_11 })
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-[52px] border-[3px] rounded-[80px] border-[var(--primary-color)]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_12 })
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-[52px] border-[3px] rounded-[80px] border-[var(--primary-color)]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_13 })
], -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "flex mb-7 mx-auto w-[899px]"
}, null, -1))
const _hoisted_56 = { class: "grid grid-cols-3 gap-x-16 mb-16" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-[52px] border-[3px] rounded-[80px] border-[var(--primary-color)]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_14 })
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-[52px] border-[3px] rounded-[80px] border-[var(--primary-color)]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_15 })
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-[52px] border-[3px] rounded-[80px] border-[var(--primary-color)]" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_16 })
], -1))
const _hoisted_60 = ["src"]
const _hoisted_61 = /*#__PURE__*/_createStaticVNode("<section class=\"grid grid-cols-3 gap-8 mb-[84px]\" data-v-181e11d4><img src=\"" + _imports_17 + "\" class=\"w-full object-cover\" data-v-181e11d4><img src=\"" + _imports_18 + "\" class=\"w-full object-cover\" data-v-181e11d4><img src=\"" + _imports_19 + "\" class=\"w-full object-cover\" data-v-181e11d4><img src=\"" + _imports_20 + "\" class=\"w-full object-cover\" data-v-181e11d4><img src=\"" + _imports_21 + "\" class=\"w-full object-cover\" data-v-181e11d4><img src=\"" + _imports_22 + "\" class=\"w-full object-cover\" data-v-181e11d4></section>", 1)
const _hoisted_62 = { class: "mb-[84px]" }
const _hoisted_63 = { class: "w-[1126px] mx-auto relative" }
const _hoisted_64 = ["src"]
const _hoisted_65 = { class: "mb-[84px]" }
const _hoisted_66 = { class: "h-[632px] w-[1362px] mx-auto relative" }
const _hoisted_67 = { class: "pl-[120px]" }
const _hoisted_68 = { class: "flex flex-row gap-x-[84px]" }
const _hoisted_69 = { class: "flex flex-col p-[20px] my-auto" }
const _hoisted_70 = { class: "flex flex-row gap-x-[92px] items-center mb-[112px]" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[72px] w-[72px] bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_72 = { class: "flex flex-row gap-x-[92px] pl-[124px] items-center" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[72px] w-[72px] bg-[var(--secondary-color)] rounded-full" }, null, -1))
const _hoisted_74 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col p-[20px] gap-y-3\" data-v-181e11d4><div class=\"flex flex-row gap-x-6 pl-[152px] p-[20px]\" data-v-181e11d4><div class=\"flex items-center justify-center h-[140px] w-[136.6px] border-[3px] border-[var(--primary-color)] rounded-full\" data-v-181e11d4><img src=\"" + _imports_23 + "\" data-v-181e11d4></div><div class=\"flex items-center justify-center h-[140px] w-[136.6px] border-[3px] border-[var(--primary-color)] rounded-full\" data-v-181e11d4><img src=\"" + _imports_24 + "\" data-v-181e11d4></div><div class=\"flex items-center justify-center h-[140px] w-[136.6px] border-[3px] border-[var(--primary-color)] rounded-full\" data-v-181e11d4><img src=\"" + _imports_25 + "\" data-v-181e11d4></div></div><div class=\"flex flex-row gap-x-6 p-[20px]\" data-v-181e11d4><div class=\"flex items-center justify-center h-[140px] w-[136.6px] border-[3px] border-[var(--primary-color)] rounded-full\" data-v-181e11d4><img src=\"" + _imports_26 + "\" data-v-181e11d4></div><div class=\"flex items-center justify-center h-[140px] w-[136.6px] border-[3px] border-[var(--primary-color)] rounded-full\" data-v-181e11d4><img src=\"" + _imports_27 + "\" data-v-181e11d4></div><div class=\"flex items-center justify-center h-[140px] w-[136.6px] border-[3px] border-[var(--primary-color)] rounded-full\" data-v-181e11d4><img src=\"" + _imports_28 + "\" data-v-181e11d4></div></div></div>", 1)
const _hoisted_75 = { class: "mb-[84px]" }
const _hoisted_76 = {
  key: 0,
  class: "flex flex-col items-center justify-center w-[1126px] mx-auto bottom_form"
}
const _hoisted_77 = {
  key: 1,
  class: "flex flex-col w-[1126px] mx-auto"
}
const _hoisted_78 = { class: "flex flex-col items-center justify-center w-full mb-[64px] p-3" }
const _hoisted_79 = { class: "p-[10px] w-[480px] text-center" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[6px] bg-[var(--secondary-color)] rounded" }, null, -1))
const _hoisted_81 = { class: "p-[10px] w-[377px] text-center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[6px] bg-[var(--secondary-color)] rounded" }, null, -1))
const _hoisted_83 = { class: "p-[10px] w-[289px] text-center" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[6px] bg-[var(--secondary-color)] rounded" }, null, -1))
const _hoisted_85 = { class: "flex flex-col items-center justify-center gap-y-12" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_29 }, null, -1))

import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import Slider from '@/components/common/Slider.vue';
import Form from '@/components/Index/Form.vue';
import arrow from '@/assets/svg/arrow.svg';
import arrowGreen from '@/assets/svg/arrow-green.svg';
import { ref, toRefs, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useWindowSize } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'MainPage',
  setup(__props) {

const { width } = useWindowSize();
const { t } = useI18n();
const router = useRouter();

const globalStore = useGlobalStore();
const { categories } = toRefs(globalStore);

const fbCategories = computed(() => categories.value.data?.slice(0, 3));
const sbCaterories = computed(() => categories.value.data?.slice(3));

const formToggleTop = ref(false);
const formToggleBottom = ref(false);
const isHoveredArrow = ref(false);

const openFormTop = () => (formToggleTop.value = !formToggleTop.value);
const openFormBottom = () => (formToggleBottom.value = !formToggleBottom.value);

const openLinkInNewTab = (url: string) => {
    window.open(url, '_blank');
};

const onCategory = (id: number) => {
    router.push({
        name: 'category',
        params: { id },
    });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", _hoisted_3, [
          _createVNode(BaseTypography, {
            text: "+7 (911) 266-00-98",
            type: _unref(width) > 1600 ? 'footnote' : 'subtitle2-m',
            color: "var(--base-white)",
            class: "shadow"
          }, null, 8, ["type"])
        ]),
        _createElementVNode("a", _hoisted_4, [
          _createVNode(BaseTypography, {
            text: "reserv@rvm-spb.ru",
            type: _unref(width) > 1600 ? 'footnote' : 'subtitle2-m',
            color: "var(--base-white)",
            class: "shadow"
          }, null, 8, ["type"])
        ]),
        _createElementVNode("a", _hoisted_5, [
          _createVNode(BaseTypography, {
            text: "info@rvm-spb.ru",
            type: _unref(width) > 1600 ? 'footnote' : 'subtitle2-m',
            color: "var(--base-white)",
            class: "shadow"
          }, null, 8, ["type"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(BaseTypography, {
          text: _unref(t)('main-page.subtitle'),
          type: "title2",
          color: "var(--base-white)",
          class: "mb-3"
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.tagline.text-1.first'),
              type: _unref(width) > 1600 ? 'headline' : 'headline2',
              tag: "span",
              color: "var(--primary-color)"
            }, null, 8, ["text", "type"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.tagline.text-1.second'),
              type: _unref(width) > 1600 ? 'headline2' : 'title',
              tag: "span",
              color: "var(--base-white)"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.tagline.text-2.first'),
              type: _unref(width) > 1600 ? 'headline' : 'headline2',
              tag: "span",
              color: "var(--primary-color)"
            }, null, 8, ["text", "type"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.tagline.text-2.second'),
              type: _unref(width) > 1600 ? 'headline2' : 'title',
              tag: "span",
              color: "var(--base-white)"
            }, null, 8, ["text", "type"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.tagline.text-3.first'),
              type: _unref(width) > 1600 ? 'headline' : 'headline2',
              tag: "span",
              color: "var(--primary-color)"
            }, null, 8, ["text", "type"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.tagline.text-3.second'),
              type: _unref(width) > 1600 ? 'headline2' : 'title',
              tag: "span",
              color: "var(--base-white)"
            }, null, 8, ["text", "type"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(BaseButton, {
            text: _unref(t)('main-page.submit'),
            type: _unref(width) > 1600 ? 'subtitle4' : 'subtitle2-m',
            "padding-x": _unref(width) > 1600 ? 'auto' : '48',
            "padding-y": _unref(width) > 1600 ? 'auto' : '0',
            class: "!h-[48px] xxl:!h-auto",
            color: "var(--base-white)",
            ui: "primary-with-back",
            onClick: openFormTop
          }, null, 8, ["text", "type", "padding-x", "padding-y"])
        ])
      ]),
      (formToggleTop.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createVNode(Form, { onClose: openFormTop })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createVNode(BaseButton, {
          text: _unref(t)('main-page.about.title'),
          type: "subtitle",
          color: "var(--black-color)",
          ui: "primary",
          class: "mb-[108px]"
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.about.subtext.text-1.first'),
              type: "subtitle",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: _unref(t)('main-page.about.subtext.text-1.second'),
              type: "subtitle2",
              tag: "span"
            }, null, 8, ["text"])
          ]),
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.subtext.text-2'),
            type: "subtitle2"
          }, null, 8, ["text"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.about.subtext.text-3'),
            type: "subtitle2"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.about.register'),
                type: "body4",
                class: "max-w-[400px]"
              }, null, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.about.league'),
                type: "body4",
                class: "max-w-[400px]"
              }, null, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.about.safety'),
                type: "body4",
                class: "max-w-[400px]"
              }, null, 8, ["text"])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.about.credibility'),
                type: "body4",
                class: "max-w-[400px]"
              }, null, 8, ["text"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("img", {
              src: _imports_4,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openLinkInNewTab('https://tourism.gov.ru/reestry/reestr-turoperatorov/show.php')))
            }),
            _createElementVNode("img", {
              src: _imports_5,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (openLinkInNewTab('https://tourligaspb.ru/team')))
            })
          ])
        ]),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            (_unref(width) > 768)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: isHoveredArrow.value ? _unref(arrowGreen) : _unref(arrow),
                  class: "w-[400px] ml-auto mt-[-22px] cursor-pointer",
                  onMouseover: _cache[2] || (_cache[2] = ($event: any) => (isHoveredArrow.value = true)),
                  onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isHoveredArrow.value = false))
                }, null, 40, _hoisted_38))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_39,
    _createElementVNode("section", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.fourth-section.first'),
            type: "title"
          }, null, 8, ["text"])
        ]),
        _hoisted_43,
        _createElementVNode("div", _hoisted_44, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.fourth-section.second'),
            type: "title"
          }, null, 8, ["text"])
        ]),
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createVNode(BaseTypography, {
            text: _unref(t)('main-page.fourth-section.third'),
            type: "title"
          }, null, 8, ["text"])
        ]),
        _hoisted_47
      ])
    ]),
    _createElementVNode("section", _hoisted_48, [
      _createElementVNode("div", _hoisted_49, [
        _createVNode(BaseButton, {
          text: _unref(t)('main-page.tours.title'),
          type: "subtitle",
          color: "var(--black-color)",
          ui: "primary",
          class: "mb-[104px]",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/categories')))
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", {
              class: "flex flex-col gap-y-[25px] items-center select-none cursor-pointer",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (onCategory(fbCategories.value[0].id)))
            }, [
              _hoisted_52,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tours.spb'),
                type: "subtitle2"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", {
              class: "flex flex-col gap-y-[25px] items-center select-none cursor-pointer",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (onCategory(fbCategories.value[1].id)))
            }, [
              _hoisted_53,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tours.russia'),
                type: "subtitle2"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", {
              class: "flex flex-col gap-y-[25px] items-center select-none cursor-pointer",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (onCategory(fbCategories.value[2].id)))
            }, [
              _hoisted_54,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tours.foreign'),
                type: "subtitle2"
              }, null, 8, ["text"])
            ])
          ]),
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", {
              class: "flex flex-col gap-y-[25px] items-center select-none cursor-pointer",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (onCategory(sbCaterories.value[0].id)))
            }, [
              _hoisted_57,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tours.school'),
                type: "subtitle2",
                class: "text-center"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", {
              class: "flex flex-col gap-y-[25px] items-center select-none cursor-pointer",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (onCategory(sbCaterories.value[2].id)))
            }, [
              _hoisted_58,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tours.medicine'),
                type: "subtitle2",
                class: "text-center"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", {
              class: "flex flex-col gap-y-[25px] items-center select-none cursor-pointer",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (onCategory(sbCaterories.value[1].id)))
            }, [
              _hoisted_59,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.tours.water'),
                type: "subtitle2",
                class: "text-center"
              }, null, 8, ["text"])
            ])
          ]),
          _createVNode(_component_router_link, { to: "/categories" }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: isHoveredArrow.value ? _unref(arrowGreen) : _unref(arrow),
                class: "w-[400px] ml-auto mt-[-22px] cursor-pointer",
                onMouseover: _cache[11] || (_cache[11] = ($event: any) => (isHoveredArrow.value = true)),
                onMouseleave: _cache[12] || (_cache[12] = ($event: any) => (isHoveredArrow.value = false))
              }, null, 40, _hoisted_60)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_61,
    _createElementVNode("section", _hoisted_62, [
      _createElementVNode("div", _hoisted_63, [
        _createVNode(BaseButton, {
          text: _unref(t)('main-page.excursion.title'),
          type: "subtitle",
          color: "var(--black-color)",
          ui: "primary",
          class: "mb-[54px]",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(router).push('/excursions')))
        }, null, 8, ["text"]),
        _createVNode(Slider, { class: "mb-16" }),
        _createVNode(_component_router_link, { to: "/excursions" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: isHoveredArrow.value ? _unref(arrowGreen) : _unref(arrow),
              class: "w-[400px] ml-auto mt-[-22px]",
              onMouseover: _cache[14] || (_cache[14] = ($event: any) => (isHoveredArrow.value = true)),
              onMouseleave: _cache[15] || (_cache[15] = ($event: any) => (isHoveredArrow.value = false))
            }, null, 40, _hoisted_64)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_65, [
      _createElementVNode("div", _hoisted_66, [
        _createElementVNode("div", _hoisted_67, [
          _createVNode(BaseButton, {
            text: _unref(t)('main-page.additional.title'),
            type: "subtitle",
            color: "var(--black-color)",
            ui: "primary",
            class: "mb-[104px]"
          }, null, 8, ["text"])
        ]),
        _createElementVNode("div", _hoisted_68, [
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _hoisted_71,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.additional.organization'),
                type: "subtitle2"
              }, null, 8, ["text"])
            ]),
            _createElementVNode("div", _hoisted_72, [
              _hoisted_73,
              _createVNode(BaseTypography, {
                text: _unref(t)('main-page.additional.reserv'),
                type: "subtitle2"
              }, null, 8, ["text"])
            ])
          ]),
          _hoisted_74
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_75, [
      (formToggleBottom.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            _createVNode(Form, {
              class: "!border-[3px] !border-[var(--secondary-color)] !rounded-[100px]",
              onClose: openFormBottom
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('main-page.ninth-section.first'),
                  type: "title",
                  class: "mb-2"
                }, null, 8, ["text"]),
                _hoisted_80
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('main-page.ninth-section.second'),
                  type: "title",
                  class: "mb-2"
                }, null, 8, ["text"]),
                _hoisted_82
              ]),
              _createElementVNode("div", _hoisted_83, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('main-page.ninth-section.third'),
                  type: "title",
                  class: "mb-2"
                }, null, 8, ["text"]),
                _hoisted_84
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _hoisted_86,
              _createVNode(BaseButton, {
                text: _unref(t)('main-page.submit'),
                type: "subtitle4",
                color: "var(--base-white)",
                ui: "primary-with-back",
                onClick: openFormBottom
              }, null, 8, ["text"])
            ])
          ]))
    ])
  ], 64))
}
}

})